<div class="flex align-center gap-8 mt-8 mb-8 mr-20 ml-20 fw-500">
  <mat-icon fontIcon="logout" class="material-symbols-outlined icon"></mat-icon>
  <h2 mat-dialog-title class="flex p-0 align-center">Session Expiring</h2>
  @if (timer) {
    <h3 class="flex p-0 align-center ml-auto">{{ timer }}</h3>
  }
</div>
<mat-dialog-content class="dialog-text">Your session will expire soon. Click OK to stay logged in.</mat-dialog-content>
<mat-dialog-actions align="end" class="mb-10">
  <button mat-flat-button class="primary-btn" (click)="close()" cdkFocusInitial>OK</button>
</mat-dialog-actions>
